import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { UserSearchComponent } from './user-search';

@NgModule({
  declarations: [UserSearchComponent],
  imports: [
    SharedModule
  ],
  exports: [UserSearchComponent],

  providers: []
})
export class UserSearchModule {}
